import React, { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import './responseModal.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

const ResponseModal = ({ handleClose, show, message, status }) => {
  const isLoading = status === 'loading';

  return (
    <Fragment>
      <Modal show={show} onHide={!isLoading ? handleClose : undefined}>
        {!isLoading && (
          <Modal.Header className="border-0" style={{ position: 'relative' }}>
            <button
              type="button"
              className="btn btn-close custom-close"
              onClick={handleClose}
              style={{
                background: '#6c757d',
                borderRadius: '0 0 0 20px',
                color: '#fff',
                border: 'none',
                fontSize: '24px',
                fontWeight: 'bold',
                padding: '10px 15px 15px 15px',
                position: 'absolute',
                right: '0px',
                top: '0px',
                cursor: 'pointer',
                lineHeight: '1',
              }}
            >
              ×
            </button>
          </Modal.Header>
        )}

        <Modal.Body
          className="text-center p-4"
          style={{ fontSize: '18px' }}
        >
          {/* Icon or Spinner */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px auto',
              background: isLoading
                ? 'transparent'
                : 'linear-gradient(45deg, #9a0cec 0%, #48bfe3 100%)',
              borderRadius: '50%',
              height: '80px',
              width: '80px',
              textAlign: 'center',
            }}
          >
            {isLoading ? (
              <div className="gradient-spinner" />
            ) : (
              <FontAwesomeIcon
                icon={status === 'success' ? faCheck : faTimes}
                style={{
                  fontSize: '60px',
                  color: '#fff',
                }}
              />
            )}
          </div>

          {/* Message */}
          {isLoading ? (
            <div style={{ fontSize: '18px' }}>Submitting your request...</div>
          ) : (
            message
          )}
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ResponseModal;
